import React from 'react';
import { Link } from 'react-router-dom';
export function Header() {
  return <header className="relative w-full" data-id="element-69" data-mp="2dme6dz3qhw3n">
      <div className="w-full h-[500px] bg-cover bg-center flex flex-col justify-center items-center relative" style={{
      backgroundImage: `url('https://uploadthingy.s3.us-west-1.amazonaws.com/nLN5FJsAUXHuWt4WkiTHYm/if-header-1920_x1080.png')`
    }} data-id="element-70" data-mp="2dn5u6nr3apjd">
        <div className="absolute inset-0 bg-black/30" data-id="element-71" data-mp="2rl46lnluobw8"></div>
        <div className="container mx-auto px-4 z-10 relative h-full" data-id="element-72" data-mp="2wl8oni2epeok">
          {/* Logo positioned on the right with responsive sizing */}
          <div className="absolute right-0 top-1/4 transform -translate-y-1/2 flex flex-col items-end w-full md:w-5/12 lg:w-5/12 pr-4 md:pr-8" data-id="element-73" data-mp="31d052zrum40z">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/pkbawTE5HWWk594wDkbqhh/if_logo.png" alt="Improbability Foundation Logo" className="w-full max-w-[350px] h-auto" data-id="element-74" data-mp="36d4qn47m5oy2" />
            {/* Small slogan below the logo, right-justified */}
            <p className="text-white text-sm md:text-base mt-6 italic text-right" data-id="element-75" data-mp="2wihxtxyo4ak9">
              Inspiring the Quest for the
              <br data-id="element-76" data-mp="2mm54j171byq1" />
              Highly Improbable
            </p>
          </div>
        </div>
      </div>
    </header>;
}